module.exports = __webpack_public_path__ + "static/media/flower-tulip.9afac069.svg";